import { createContext, useContext } from 'react';
import { useSavedList } from './useSavedList';

const WishlistContext = createContext({});

export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const [wishlistItems, setWishlistItems, { removeSavedItems, restoreSavedItems }] = useSavedList('wishlist', 'wishlist');

  const addToWishlist = (product) => {
    if (wishlistItems.some((item) => item.id === product.id)) {
      removeSavedItems([product.id]);
      return;
    }
    restoreSavedItems([product.id]);
    setWishlistItems((current) => current.some((item) => item.id === product.id) ? current : [...current, product]);
  };

  const removeFromWishlist = (id) => removeSavedItems([id]);

  const totalWishlist = wishlistItems.length;

  const value = {
    wishlistItems,
    addToWishlist,
    removeFromWishlist,
    totalWishlist,
  };

  return (
    <WishlistContext.Provider value={value}>
      {children}
    </WishlistContext.Provider>
  );
};
